// import request from '@/utils/request'
//
// // 文件上传
// export function uploadFile(data) {
//   return request({
//     url: '/system/file/upload',
//     method: 'post',
//     data: data,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   })
// }
//
// // 文件下载
// export function downloadFile(fileId) {
//   return request({
//     url: '/system/file/download/' + fileId,
//     method: 'get',
//     responseType: 'blob'
//   })
// }
//
// // 删除文件
// export function deleteFile(fileId) {
//   return request({
//     url: '/system/file/delete/' + fileId,
//     method: 'delete'
//   })
// }


import request from '@/utils/request'

// 根据id查询文件信息
export function listByIds(ids) {
  return request({
    url: '/oss/file' + '/' + ids,
    method: 'get'
  })
}


// 上传文件
export function uploadFile(data) {
  return request({
    url: '/oss/file/upload',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 分片上传前校验
 */

